import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.permissions.title',
    defaultMessage: 'Manage Permissions',
  },
});

function PermissionsPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Permissions.List />
    </AdminManagement.Layout>
  );
}

export default PermissionsPage;
